import {
  filters,
  cards,
  rows,
  legal_matter_drawer_catalog,
  ai_briefing,
  ai_questions
} from './legal_matters_data';
import {
  legal_matter_record_icon,
  legal_matter_check_icon,
  legal_matter_check_state_class,
  legal_matter_check_badge_class
} from './legal_matters_helpers';

export default {
  name: 'ComplyonLegalMatters',
  data: () => ({
    filters,
    active_filter: 'all',
    search_query: '',
    active_matter_ref: null,
    cards,
    rows,
    ai_briefing,
    ai_questions
  }),
  computed: {
    filtered_rows() {
      const search = this.search_query.trim().toLowerCase();

      return this.rows.filter((row) => {
        const matches_filter = this.active_filter === 'all' || row.filter_id === this.active_filter;
        if (!matches_filter) {
          return false;
        }

        if (!search) {
          return true;
        }

        const haystack = [row.ref, row.matter, row.case_type, row.parties, row.attorney, row.risk, row.status.label]
          .join(' ')
          .toLowerCase();

        return haystack.includes(search);
      });
    },
    active_matter() {
      return this.rows.find((row) => row.ref === this.active_matter_ref) || null;
    },
    active_matter_drawer() {
      return this.active_matter_ref ? legal_matter_drawer_catalog[this.active_matter_ref] || null : null;
    }
  },
  methods: {
    set_filter(filter_id) {
      this.active_filter = filter_id;
    },
    open_matter_drawer(row) {
      if (!row?.ref) {
        return;
      }

      this.active_matter_ref = row.ref;
    },
    close_matter_drawer() {
      this.active_matter_ref = null;
    },
    legal_matter_record_icon,
    legal_matter_check_icon,
    legal_matter_check_state_class,
    legal_matter_check_badge_class
  }
};
